import React from 'react'
import { Link, Redirect } from '@reach/router'

import PropertyCard from '@components/PropertyCard'

export default function PropertiesList(props: any) {
  let properties = props.properties
  let preorderProperties = Object.values(properties).filter(
    (property: any) => property.status == 'Pre-Order'
  )
  let secondaryProperties = Object.values(properties).filter(
    (property: any) => property.status == 'Secondary Market'
  )
  return (
    <React.Fragment>
      <div className="Section -mod-margin-bottom-3">
        <div className="Wrapper -wide">
          <h2 className="Heading -four -mod-margin-bottom-2 -mod-margin-top-2">
            Preorder Properties
          </h2>
          <ul className="Grid -two -spaced">
            {preorderProperties.map((property: any) => {
              return (
                <li key={property.id}>
                  <PropertyCard property={property} showFixedMortgageDesc={false}>
                    <div className="Row">
                      <Link
                        to={'/properties/' + property.id}
                        className="Button -light-grey -mod-margin-top"
                      >
                        View details
                      </Link>
                    </div>
                  </PropertyCard>
                </li>
              )
            })}
          </ul>
        </div>
        <div className="Section ">
          <div className="Wrapper -wide">
            <h2 className="Heading -four -mod-margin-bottom-2 -mod-margin-top-2">
              Secondary Market Properties
            </h2>
            <ul className="Grid -two -spaced">
              {secondaryProperties.map((property: any) => {
                return (
                  <li key={property.id}>
                    <PropertyCard property={property}  showFixedMortgageDesc={false}>
                      <div className="Row">
                        <Link
                          to={'/properties/' + property.id}
                          className="Button -light-grey -mod-margin-top"
                        >
                          View details
                        </Link>
                      </div>
                    </PropertyCard>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}
